export default __webpack_public_path__ + "static/img/le-tinte.f3f73e9.png";